import React from "react"
import { useNavigate } from "react-router-dom"

import { logoText } from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { ROUTES } from "src/App"

import { socialLinksForFooter } from "@fuse/utils/DeviceDection"

export interface IFooter {
  className?: string
}

const Footer: React.FC<IFooter> = ({ className = "" }) => {
  const navigate = useNavigate()

  const onLandingPage = () => {
    navigate(ROUTES.LANDING)
  }

  const handleButtonClick = (url: string) => {
    window.open(url, "_blank")
  }

  return (
    <div className={`flex w-full items-center justify-center ${className}`}>
      <header className="flex flex-1 justify-between items-center px-4 md:px-8 py-8 max-w-screen-xl 2xl:max-w-screen-2xl sm:mx-[30px] md:mx-[50px]">
        <FancyText
          className="text-[24px] cursor-pointer"
          style={logoText}
          onClick={onLandingPage}
        >
          Let’s Hang!
        </FancyText>

        <div className="flex gap-8">
          {socialLinksForFooter?.map((item, index) => {
            return (
              <button
                key={index.toString()}
                className="bg-transparent p-0 border-none outline-none"
                onClick={() => handleButtonClick(item.linkUrl)}
              >
                <img src={item?.icon} alt={item?.name} className="h-4 md:h-6" />
              </button>
            )
          })}
        </div>
      </header>
    </div>
  )
}

export default Footer
